import { render, staticRenderFns } from "./platform_controls.vue?vue&type=template&id=7528b24c&scoped=true&"
import script from "./platform_controls.vue?vue&type=script&lang=js&"
export * from "./platform_controls.vue?vue&type=script&lang=js&"
import style0 from "./platform_controls.vue?vue&type=style&index=0&id=7528b24c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528b24c",
  null
  
)

export default component.exports